
<main class="container-fluid module-container">
  <div class="content-container">
    <div class="card-body">
      <div class="loading-containerReports" *ngIf="loading">
        <section>
          <div  class="pulsing">
            <mat-spinner [diameter]="50" ></mat-spinner>
          </div>
          <p class="pulsing">{{"Loading" | translate}}</p>
        </section>
      </div>
      <mat-form-field class="card-body-reports" [ngClass]="isDisabledReport ? 'disappear' : undefined">
          
          <mat-label class="filters-label"> *{{ "Information" | translate }}</mat-label>
          <mat-select [(ngModel)]="reportId" >
            <mat-option 
              *ngFor="let reportType of reportsList | async"
              (click)="getNameCompany()" 
              [value]="reportType.reportId"
              > 
              {{reportType.reportName | translate}} 
            </mat-option>
          </mat-select>  
      </mat-form-field>

        <!-- Filters -->
        <div class="card-body-components"  [ngClass]="isDisabled ? 'disappear' : undefined">
          <div class="card-body-tittle" *ngIf="roleId === 4"><strong>{{ "Company" | translate }}:</strong>
            <label>{{companyName}}</label>
          </div>
          <mat-form-field class="card-body-dropdown" *ngIf="roleId === 3">
              <mat-label class="filters-label" >{{ "Company" | translate }}*</mat-label>
              <mat-select [disabled]="disableCompany" [(ngModel)]="companyId" >
                <mat-option 
                  *ngFor="let dataCompany of companiesName"
                  (click)="getNameLocation()"
                  [value]="dataCompany.CompanyId"> 
                  {{dataCompany.CompanyName}} 
                </mat-option>
              </mat-select>
          </mat-form-field>
          <mat-form-field class="card-body-dropdown">
            <mat-label class="filters-label">{{ "Location" | translate }}*</mat-label>
            <mat-select [disabled]="disableLocation"
            [(ngModel)]="LocationId"
            > 
              <mat-option 
                *ngFor="let dataLocation of locationData"
                (click)="getNameDeparment()"
                [value]="dataLocation.LocationId"
                > 
                {{dataLocation.LocationName}} 
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="card-body-dropdown">
            <mat-label class="filters-label">{{ "Department" | translate }}*</mat-label>
            <mat-select [(ngModel)]="DeparmentCode" [disabled]="disableDepartment"> 
              <mat-option 
              *ngFor="let department of departmentData " 
              (click)="getNameBrandServiceResource()"
              [value]="department.Department"
              > 
              {{department.DepartmentName}} 
            </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="card-body-dropdown">
            <mat-label class="filters-label">{{ "Brand" | translate }}*</mat-label>
            <mat-select [(ngModel)]="makeCode" [disabled]="disableBrands" multiple> 
              <mat-option 
              (click)="disabledDropdowns('brand')"
              *ngFor="let brand of brandData" 
              [value]="brand.Make"
              > 
              {{brand.MakeName}} 
            </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="card-body-dropdown">
            <mat-label class="filters-label">{{ "Service" | translate }}*</mat-label>
            <mat-select [(ngModel)]="serviceId" [disabled]="disableServices"> 
              <mat-option 
              (click)="disabledDropdowns('service')"
              *ngFor="let service of serviceData"
              [value]="service.ServiceId"> 
              {{service.ServiceName}} 
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="card-body-dropdown"
          *ngIf="roleId === 3">
            <mat-label class="filters-label" >{{ "Resource" | translate }}*</mat-label>
            <mat-select [(ngModel)]="ResourceId" [disabled]="disableResource"> 
              <mat-option 
                (click)="disabledDropdowns('resource')"
                *ngFor="let resource of resourceData"
                [value]="resource.ResourceId"
                > 
                {{resource.ResourceName | translate}} 
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Calendar -->
        <div class="row"[ngClass]="isDisabled ? 'disappear' : undefined">
          <div class="col-lg-2 card-body-calendar-from">
            <mat-form-field class="size-dropdown">
              <mat-label class="filters-label"> {{ "From" | translate }}</mat-label>
              <input 
                matInput 
                [matDatepicker]="fromPicker" 
                [(ngModel)]="startDate"
                (ngModelChange)="ChangeDateEnd()"
              />
              <mat-datepicker 
                #fromPicker>
              </mat-datepicker>
              <mat-datepicker-toggle 
                matSuffix [for]="fromPicker"
              >
                <mat-icon matDatepickerToggleIcon>
                  <div>
                    <img
                      src="../../assets/calendar.svg"
                      alt="calendar icon"
                    />s
                  </div>
                </mat-icon>
              </mat-datepicker-toggle>
            </mat-form-field>
          </div>

          <div class="col-lg-2 card-body-calendar-to">
            <mat-form-field class="size-dropdown" >
              <mat-label class="filters-label">{{ "To" | translate }}</mat-label>
              <input
                matInput
                [matDatepicker]="toPicker"
                [(ngModel)]="endDate"
                [matDatepickerFilter]="dateFilterEnd"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="toPicker"
              > 
                <mat-icon matDatepickerToggleIcon>
                  <div>
                    <img
                      src="../../assets/calendar.svg"
                      alt="calendar icon"
                    />
                  </div>
                </mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker
                #toPicker>
              </mat-datepicker>
            </mat-form-field>
          </div>

          <!-- Search and clearfilter buttons -->
          <div class="button-clean-search">
            <button
              class="button-clean"
              (click)="clearFilter()"
            >
              {{"Clean" | translate}}
            </button>

            <button 
              class="-button-search"
              (click)="searchReport(0)"
              [disabled]="isSearchDisable()"
              [ngClass]="{isDisabled: isSearchDisable(),isEnabled:!isSearchDisable()}"
            >
              {{"Consult" | translate}}
            </button>
          </div>
        </div>
    </div> 

    <div class="loading-container" *ngIf="isLoading">
      <section>
        <div  class="pulsing">
          <mat-spinner [diameter]="50" ></mat-spinner>
        </div>
        <p class="pulsing">{{"Searching" | translate}}</p>
      </section>
    </div>

    <ng-container *ngIf="dataShow.length > 0">

      <!-- Export Button -->
    <div class="header-button">
        <button class="export-button" (click)="getReport(1)" >
          <i class="material-icons-outlined">download</i><p>{{ "Export" | translate }}</p>
        </button>
      

      <!-- Grid -->
      <table 
        class="table-report scrollable-table"
      >
          <thead class=" desing-head">
              <tr class="row report-headers" >
                  <th class="col tittle1" *ngFor="let test of textHeaders">{{ test | translate}}</th>
                  <th class="col tittle1">Total</th>
              </tr>
          </thead>
        <tbody class="design-body">
            <tr class="row design-body-principal" *ngFor="let post of dataShow; let i = index">
              <td class="col design-body-td" *ngFor="let test of textHeaders; let i = index" [class.firstTd]="i === 0" >{{post[test]}}</td>
              <td [ngStyle]="{'background-color': 'var(--brand-primary-color)', 'color': 'white'}" >{{rowTotals[i]}}</td>
            </tr>
        </tbody>

        <tfoot class="foot-report" >
          <tr  class="row design-body-principal">
            <td class="foot-report-td" *ngFor="let totalFoot of total ">{{totalFoot}}</td> 
            <td class="foot-report-td" >{{sumtotalColumn}}</td>
          </tr>
        </tfoot>
      </table>
    </div>
    </ng-container>

    <!-- Message when there is no data in the report-->
    <div *ngIf="dataShow.length <= 0 && dataSearched ">
      <p class="messageReport">
        <strong>{{ "NoDataInReport" | translate }}
        </strong>
      </p>
    </div>

  </div>
</main>